import { render, staticRenderFns } from "./ConfigManager.vue?vue&type=template&id=b7fa3128&scoped=true&"
import script from "./ConfigManager.vue?vue&type=script&lang=js&"
export * from "./ConfigManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7fa3128",
  null
  
)

export default component.exports